import { Helmet } from "react-helmet-async";
import { LOCALES } from "../../i18n/messages";
import { buildPath, stripLangFromPath } from "../../utils/routing";

const SITE_ORIGIN =  "https://chronosartenode.com";

export default function Seo({ locale, title, description, image = "/assets/brand-logo.png", path = "/" }) {
  const canonicalUrl = `${SITE_ORIGIN}${path}`;
  const { localPath } = stripLangFromPath(path.split("?")[0] || "/");
  const localSlug = localPath === "/" ? "" : localPath.slice(1);
  const query = path.includes("?") ? path.slice(path.indexOf("?")) : "";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href={canonicalUrl} />
      {Object.entries(LOCALES).map(([lang]) => {
        const href = `${SITE_ORIGIN}${buildPath(lang, localSlug)}${query}`;
        const hreflang = lang === "zh-Hans" ? "zh-CN" : lang === "zh-Hant" ? "zh-TW" : lang;
        return <link key={lang} rel="alternate" hrefLang={hreflang} href={href} />;
      })}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Chronos Arte Node" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={`${SITE_ORIGIN}${image}`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${SITE_ORIGIN}${image}`} />
      <html lang={LOCALES[locale]?.code || "zh-CN"} />
    </Helmet>
  );
}
